const styles = {
  nodeCard: {
    cursor: 'grab',
    transition: 'all 0.2s ease',
    '&:hover': {
      transform: 'translateY(-2px)',
      boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
    },
    '&:active': {
      cursor: 'grabbing',
      transform: 'scale(0.95)'
    }
  },
  nodeCardContent: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    padding: '12px !important'
  },
  nodeIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: '24px'
  },
  nodeLabel: {
    fontSize: '0.9rem',
    fontWeight: 500,
    flex: 1
  }
};

export default styles;
